import DataModel from "./DataModel";

class IntegrationType extends DataModel {
	constructor() {
		super('integrations/types')
	}
}

export default IntegrationType;
